import { UpdatedLog, UpdatedRecordsType } from '@/types/logs'
import { getUnfinishedType } from '@/pages/UnfinishedRecords/helpers/markUpdatedRecords'

const formatChangedProperties = (log: UpdatedLog): UpdatedLog => ({
    ...log,
    propertiesChanged: (log.propertiesChanged || []).map((item) => item.toLocaleLowerCase()),
})

export const groupUpdatedRecords = (logs: UpdatedLog[]): UpdatedLog[] => {
    const result: UpdatedLog[] = []

    logs.forEach((log) => {
        const groupId = crypto.randomUUID()
        const unfinishedType = getUnfinishedType(log)
        if (unfinishedType === UpdatedRecordsType.Unfinished) {
            result.push(
                { ...log.unfinishedVersion, groupId, unfinishedType },
                formatChangedProperties({ ...log, groupId })
            )
            return
        }

        if (unfinishedType === UpdatedRecordsType.Flagged) {
            result.push({ ...log, groupId, unfinishedType }, formatChangedProperties({ ...log, groupId }))
            return
        }

        if (unfinishedType === UpdatedRecordsType.MissingInfo) {
            result.push({ ...log, groupId, unfinishedType }, formatChangedProperties({ ...log, groupId }))
            return
        }

        if (unfinishedType === UpdatedRecordsType.MissingOfficialReport) {
            result.push({ ...log, groupId, unfinishedType }, formatChangedProperties({ ...log, groupId }))
            return
        }

        result.push(formatChangedProperties({ ...log, unfinishedType: UpdatedRecordsType.New, groupId }))
    })

    return result
}
